import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { UserProfileDetailView } from './UserProfileDetailView'
import { UserProfileEditView } from './UserProfileEditView'
import { UserProfilesListView } from './UserProfilesListView'

export const UserProfilesView: React.FC = () => {
  return (
    <Routes>
      <Route path="show/:id" element={<UserProfileDetailView />} />
      <Route path="edit/:id" element={<UserProfileEditView />} />
      <Route path="" element={<UserProfilesListView />} />
    </Routes>
  )
}
